<div class="db-payment-method" [ngClass]="{'db-from-upgrade': fromUpgrade, 'active': selectable ? selected : paymentMethod && paymentMethod.active, 'db-payment-method_selectable': selectable}" (click)="selectable && select()">
  <div [ngClass]="{'inactive': !(selectable ? selected : paymentMethod?.active), 'active': selectable ? selected : paymentMethod?.active}">
    <!--<div class="db-selected-payment-method" *ngIf="fromUpgrade">
      <span [ngClass]="{'active': selectable ? selected : paymentMethod?.active}" (click)="setDefault('main')"><i *ngIf="selectable ? selected : paymentMethod?.active" class="db-icon db-icon-checkbox-round"></i></span>
    </div>-->
    <div class="db-payment-method__card-information">
      <div class="db-payment-method-card-info">
        <div class="db-card-number">
          <div [ngClass]="{'inactive': !(selectable ? selected : paymentMethod?.active)}" class="db-payment-card_image mr8 {{paymentMethod?.creditCard?.type}}"></div>
          <div class="db-payment-method__card-info">
            <div>&#9679;&#9679;&#9679;&#9679;</div>
            <div class="db-card-number-separator"></div>
            <div class="db-card-last-numbers">{{paymentMethod?.creditCard?.number}}</div>
          </div>
        </div>
        <div class="ds-payment-method__exp-date">
          <span>{{ 'text_expDate' | dbText}}: </span>
          <span>{{paymentMethod?.creditCard?.expireMonth}}/{{paymentMethod?.creditCard?.expireYear}}</span>
        </div>
      </div>
      <div class="db-main-card-identifier" *ngIf="paymentMethod?.active && !fromUpgrade && (userSubscription?.paymentType === 'card' && (userSubscription?.type === UserSubscriptionType.PREMIUM || userSubscription?.type === UserSubscriptionType.ONE_PRODUCT || userSubscription?.type === UserSubscriptionType.FREE))" [ngClass]="{'db-additional-method': !withShadow}">
        <span *ngIf="withShadow" class='db-active-check black ml8'><i class="db-icon db-icon-checkbox-round"></i></span>
        <span class="db-main-card-identifier-title">{{(withShadow ? 'text_mainPaymentMethod' : 'text_defaultForAdditional') | dbText}}</span>
      </div>
      <div class="db-payment-method__dropdown "
           *ngIf="(userSubscription?.status === 'canceled' || userSubscription?.isExpired || !withShadow || (!paymentMethod?.active || (userSubscription?.paymentType !== 'card' && paymentMethod?.active && (userSubscription?.type === UserSubscriptionType.PREMIUM || userSubscription?.type === UserSubscriptionType.ONE_PRODUCT || userSubscription?.type === UserSubscriptionType.FREE)))) && !fromUpgrade && showDropdown && (!default || (default && !userSubscription?.hasActiveDomainAgreement))"
           [dsTooltip]="actionsRef" dsTooltipMode="click"
           dsTooltipAlign="right" dsTooltipSize="small"
           [className]="'payment-method ml16'">
        <a class="more-icon-wrap"><i class="db-icon db-icon-ds-more-l"></i></a>
      </div>
    </div>
  </div>
</div>

<ng-template #actionsRef>
  <div class="db-payment-method__list" >
    <p *ngFor="let paymentMethod of paymentMethodActions; let i = index"
       [ngClass]="{'mt5': i !== 0}">
      <span (click)="paymentMethod?.action()">{{paymentMethod?.label}}</span>
    </p>
  </div>
</ng-template>
